module.exports = __webpack_public_path__ + "img/img0.968f5076.jpg";